import axios, { AxiosStatic } from "axios";
import { HrRepresentative } from "@teamprevent/common/hrRepresentatives/models";

export class HrRepresentativesApi {

    private axios: AxiosStatic;

    constructor(ax: AxiosStatic) {
        this.axios = ax;
    }

    public async getAll(): Promise<HrRepresentative[]> {
        const response = await this.axios.get("/api/hrrepresentatives");
        const model = response.data as HrRepresentative[];
        return model;
    }
}

export default new HrRepresentativesApi(axios);
